import React from "react";
var __jsx = React.createElement;
import { SvgIcon } from "@mui/material";
export default function CalendarIcon() {
  return /*#__PURE__*/React.createElement(SvgIcon, {
    viewBox: "0 0 70 128",
    height: "24",
    width: "24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.94 36.12L62 29 35 56 8 29l-7 7 27 27L1 90l7 7 27-27 27 27 7-7-27-27 26.94-26.88"
  }));
}
CalendarIcon.defaultProps = {
  fontSize: "inherit"
};